"use client";

import React, { useEffect, useState } from 'react';
import Link from 'next/link';

type Consent = {
    essential: boolean;
    analytics: boolean;
    marketing: boolean;
    partnersCount?: number;
};

const STORAGE_KEY = 'cookieConsent';

export default function CookieBanner() {
    const [visible, setVisible] = useState(false);
    const [consent, setConsent] = useState<Consent | null>(null);

    useEffect(() => {
        try {
            const raw = localStorage.getItem(STORAGE_KEY);
            if (!raw) {
                setVisible(true);
            } else {
                setConsent(JSON.parse(raw));
            }
        } catch (e) {
            setVisible(true);
        }
    }, []);

    const saveConsent = (c: Consent) => {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(c));
        setConsent(c);
        setVisible(false);
        try {
            // notify other listeners (same tab) that consent changed
            window.dispatchEvent(new Event('cookieConsentChanged'));
        } catch (e) { }
    };

    const acceptAll = () => saveConsent({ essential: true, analytics: true, marketing: true, partnersCount: 210 });
    const rejectNonEssential = () => saveConsent({ essential: true, analytics: false, marketing: false, partnersCount: 210 });

    if (!visible) return null;

    return (
        <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-8 z-50">
            <div className="max-w-5xl mx-auto bg-white/95 dark:bg-gray-800/95 border rounded-lg p-4 shadow-lg text-sm text-gray-900 dark:text-gray-100">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
                    <div>
                        <div className="font-semibold">Privacy & cookies</div>
                        <div className="mt-1">We and our partners use technologies, including cookies, to personalize content and ads, measure content performance and audience insights, and develop services. Your device information may be stored and shared with partners (approx. <strong>210 partners</strong>).</div>
                        <div className="mt-2">
                            <Link href="/politika-privatnosti" className="underline mr-4">Learn more</Link>
                            <Link href="/privacy-cookie-settings" className="underline">Privacy and cookie settings</Link>
                        </div>
                    </div>

                    <div className="flex items-center gap-2 md:gap-3">
                        <button onClick={rejectNonEssential} className="px-3 py-2 border rounded-md text-sm bg-white hover:bg-gray-50">Reject non-essential</button>
                        <button onClick={acceptAll} className="px-3 py-2 bg-blue-600 text-white rounded-md font-semibold">Accept all</button>
                    </div>
                </div>
            </div>
        </div>
    );
}
